import React from 'react';
import { useNavigation } from '../../contexts/NavigationContext';
import MobileCommunityView from './MobileCommunityView';
import DesktopCommunityView from './DesktopCommunityView';

function ResponsiveCommunityView() {
  const { isMobile } = useNavigation();

  return isMobile ? <MobileCommunityView /> : <DesktopCommunityView />;
}

export default ResponsiveCommunityView;
